import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-direct-apply-landing',
  standalone: true,
  imports: [],
  templateUrl: './direct-apply-landing.component.html',
  styleUrl: './direct-apply-landing.component.scss'
})
export class DirectApplyLandingComponent {
  @Output() startApplication = new EventEmitter<string>();

  onStart(mode: string) {
    this.startApplication.emit(mode);
  }
}
